import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
export default (function ($prop, ctx) {
  ctx.$on('popup:open', function () {
    var save = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var content, tags, show_name, rs;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                content = $('textarea[name="question-content"]').val();
                tags = $('input[name="tags"]').val();
                show_name = $('input[name="show_name"]').prop('checked') ? 1 : null;

                if (!(content.trim() === '')) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", false);

              case 5:
                _context.next = 7;
                return Base.api('Faq', 'saveQuestion', {
                  content: content,
                  tags: tags,
                  show_name: show_name
                });

              case 7:
                rs = _context.sent;

                if (rs.result === 'success') {
                  Base.app.emit('questionCreated', rs.row);
                  Utils.notiInfo('Đã lưu lại thành công');
                  $('textarea[name="question-content"]').val('');
                  $('input[name="tags"]').val('');
                  $('input[name="show_name"]').prop('checked', false);
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function save() {
        return _ref.apply(this, arguments);
      };
    }();

    $('.save-question').click(function (e) {
      Base.app.dialog.confirm('Bạn chắc chắn Lưu lại bản này chứ?', function () {
        save();
      });
    });
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="popup" data-name="faq-question-popup">
    <div class="view">
      <div class="page">
        <div class="navbar">
          <div class="navbar-bg"></div>
          <div class="navbar-inner">
            <div class="title">Đặt câu hỏi</div>
            <div class="right">
              <a href="#" class="link popup-close"><i class="icon f7-icons">multiply</i></a>
            </div>
          </div>
        </div>
        <div class="toolbar toolbar-bottom">
          <div class="toolbar-inner">
            <a href="#" class="button save-question">Lưu lại</a>
          </div>
        </div>
        <div class="page-content">

          <div class="block-title">Câu hỏi/Vấn đề của khách</div>
          <div class="list no-hairlines no-margin">
            <ul>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-input-wrap">
                      <textarea name="question-content" cols="30" rows="20" style="height: 75vw;" placeholder=""></textarea>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-input-wrap">
                      <input type="text" name="tags" placeholder="Thẻ tìm kiếm (phân cách bằng dấu ,)"/>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <label class="item-checkbox item-content">
                  <input type="checkbox" name="show_name" />
                  <i class="icon icon-checkbox"></i>
                  <div class="item-inner"><div class="item-title">Hiện tên người viết?</div></div>
                </label>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  </div>
`
    }
    ;
});